import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/physical-security/dome-turret/ai-turret.png";
import type { Product } from "../../types";
import { physicalSecurityDomeTurret } from "../product-list-groups/physicalSecurityDomeTurret";
import { deployment, outdoorReady } from "../properties";

export const aiTurret: Product = {
  id: "aiTurret",
  productTitle: "AI Turret",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.CamerasNVRs}/uvc-ai-turret`,
  ],
  storePathParts: {
    productSlug: "uvc-ai-turret",
    category: UniFiChildCategorySlug.CamerasDomeTurret,
  },
  sku: "UVC-AI-Turret",
  description: "aiTurret.description",
  image: { src: image, width: 200, height: 140 },
  productListGroup: physicalSecurityDomeTurret,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: 'Ø118 x 111 mm\n(Ø4.6 x 4.4")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "4K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '1/1.8" 8MP' },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "aiTurret.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: {
        type: "translation",
        value: "aiTurret.nightVision",
      },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "aiRecognition",
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "cameraAudio",
      value: {
        type: "translation",
        value: "commons.cameraAudio.twoWayAudio",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "string", value: "IP66" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK08" },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE+" },
    },
  ],
};
